import { render } from "./ComoParticiparView.vue?vue&type=template&id=751d0f75&scoped=true"
const script = {}

import "./ComoParticiparView.vue?vue&type=style&index=0&id=751d0f75&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751d0f75"]])

export default __exports__